import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from './LogoutButton';

const Welcome = () => {
    const {isAuthenticated, user} = useAuth0();
  
    
    return (
      !isAuthenticated && (
        <div>
              <div class = "container jumbotron-top" id = "main-welcome">
			        <div class = "head-text">
			        	<h2 class="head-title"><span>Welcome to the MetroHacks EmpowHer Participant Portal!</span></h2>
				          <br></br>
				            <p class="center head-subtitle"><span>To get started, please create an account or log in to your account. If you're creating an account, clicking the button below will allow you to do so.</span></p>

				              <div class = "row">
					              <div class="content center">
						
            
            
					
				</div>
			</div>
		</div>
	</div>
        </div>
            





        
        
      )
    );
  };
  
  export default Welcome;